<!-- 选项卡-价格 -->
<template>
  <div class="tabs-price">
    <el-tabs v-model="activeIndex" type="border-card" @tab-click="tabToggle">
      <el-tab-pane v-for="(item, index) in navList" :key="index" :label="item.key" :name="item.val">
        <slot />
      </el-tab-pane>
    </el-tabs>
    <router-view />
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeIndex: '',
      navList: [
        {
          key: `设置${this.type}`,
          val: `设置${this.type}`
        },
        {
          key: `校验${this.type}`,
          val: `校验${this.type}`
        }
      ]
    }
  },
  mounted() {
    this.activeIndex = this.index
  },
  methods: {
    tabToggle() {
      this.$emit('update:index', this.activeIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.tabs-price {
  /deep/ .el-tabs {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__content {
      padding: 10px;
    }
  }
}
</style>
